<template>
    <div id="app" v-if="loaded">
        <div class="header">
            <transition name="fade">
                <router-link tag="div" :to="{name:'order'}" v-if="$route.name === 'review'" class="nav-back">
                    <icons icon="chevron-left"></icons>
                    Back
                </router-link>
                <router-link tag="div" :to="{name:'home'}" v-if="$route.name === 'order'" class="nav-back">
                    <icons icon="chevron-left"></icons>
                    Back
                </router-link>
                <router-link tag="div" :to="{name:'home'}" v-if="$route.name === 'confirmation'" class="nav-back">
                    <icons icon="chevron-left"></icons>
                    Home
                </router-link>
                <div class="nav" v-if="$route.name === 'home' && menuReady">
                    <div class="menu-toggle" @click="menuOpen = !menuOpen">
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                    <transition name="fade-down">
                        <ul v-if="menuOpen && autoHideMenu || !autoHideMenu">
                            <li :class="{'active': trigger === 'what-is-it'}">
                                <a href="#what-is-it" @click="menuOpen = false">What is it?</a>
                            </li>
                            <li :class="{'active': trigger === 'fabric'}">
                                <a href="#fabric" @click="menuOpen = false">Fabric</a>
                            </li>
                            <li :class="{'active': trigger === 'hardware'}">
                                <a href="#hardware" @click="menuOpen = false">Hardware</a</li>
                            <li :class="{'active': trigger === 'sizes'}">
                                <a href="#sizes" @click="menuOpen = false">Sizes</a>
                            </li>
                            <li :class="{'active': trigger === 'colors'}">
                                <a href="#colors" @click="menuOpen = false">Colors</a>
                            </li>
                        </ul>
                    </transition>
                </div>
            </transition>
            <div class="cart" v-if="$route.name !== 'review' && $route.name !== 'confirmation'">
                <div :class="{'cart-icon': true, 'open': cartOpen}" @click="cartOpen = !cartOpen">
                    <icons icon="cart"></icons>
                    CART <span v-if="cartItems.length > 0">({{ cartItems.length }})</span>
                </div>
                <div :class="{'cart-menu': true, 'open': cartOpen}">
                    <popup-cart @hideCart="cartOpen = false"></popup-cart>
                </div>
            </div>
        </div>
        <div @click="menuOpen = cartOpen = false" id="main">
            <transition :name="activeTransition" mode="out-in">
                <router-view @triggered="captureTrigger" @openCart="cartOpen = true"
                             @closeCart="cartOpen = false"></router-view>
            </transition>
            <div class="footer">
                <div>
                    <img class="footer-logo" src="/img/hilsport.svg">
                    <br />
                    All Rights Reserved
                    <br />
                    Copyright &copy; 2020
                    <br />
                    Made in USA
                    <br />
                    <br />
                    <a href="https://goo.gl/maps/nBsFnS5sxVG2" target="_blank">
                        25691 Altas Palmas Rd
                        <br />
                        Harlingen, TX 78552
                    </a>
                </div>
                <div>
                    <strong>Get in touch</strong>
                    <br />
                    Call <strong><a href="tel:18004519236">1 (800) 451-9236</a></strong>
                    <br />
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <strong><a href="tel:19564231885">1 (956) 423-1885</a></strong>
                    <br />
                    Email <strong><a href="mailto:service@hilsport.com">service@hilsport.com</a></strong>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss">
    @import "./scss/main.scss";
</style>

<script>
import {mapGetters} from "vuex"
import * as types   from "./store/types"

export default {
  name: 'App',
  data: () => ({
    loaded: false,
    cartOpen: false,
    trigger: '',
    menuOpen: false,
    menuReady: false,
    autoHideMenu: true,
    activeTransition: 'page-forward',
  }),
  computed: mapGetters(['cartItems']),
  beforeMount() {
    this.$store.dispatch(types.FETCH_CART).then(data => {
      if (this.$store.state.cart.items.length > 0) {
        this.$store.dispatch(types.FETCH_PAYMENT_AUTHORIZATION)
      }
      if (this.$route.name === 'review' && this.$store.state.cart.items.length < 1) {
        this.$router.push({ name: 'order' })
      }
      if (this.$route.name === 'confirmation' && this.$store.state.order === false) {
        this.$router.push({ name: 'order' })
      }
    })
    window.addEventListener('resize', () => {
      setTimeout(() => {
        this.resized()
      }, 500)
    })
  },
  mounted() {
    this.resized();
    this.loaded = true;
    setTimeout(() => {
      this.menuReady = true;
    }, 1000);
  },
  beforeDestroy() {
    window.removeEventListener('resize', () => {
      setTimeout(() => {
        this.resized()
      }, 500)
    })
  },
  methods: {
    resized() {
      this.menuOpen     = window.outerWidth >= 768
      this.autoHideMenu = window.outerWidth < 768
    },
    captureTrigger(trigger) {
      this.trigger = trigger
    },
    routeUpdated(to, from) {
      const toDepth   = to.path.split('/').length
      const fromDepth = from.path.split('/').length

      let transition = 'page-forward'

      if (from.name === 'home' && to.name === 'order' || from.name === 'order' && to.name === 'review') {
        transition = 'page-forward'
      }
      else if (from.name === 'order' && to.name === 'home') {
        transition = 'page-backward'
      }
      else if (from.name === 'review' && to.name === 'order' || from.name === 'review' && to.name === 'home') {
        transition = 'page-backward'
      }
      else {
        transition = toDepth === fromDepth
          ? transition
          : toDepth < fromDepth ? 'page-forward' : 'page-backward'
      }

      this.activeTransition = transition
    }
  },
  watch: {
    $route: 'routeUpdated'
  }
}
</script>


// WEBPACK FOOTER //
// App.vue?262acfb3